import {getNormalizedEnvironment} from '@vio/core/src/_web/utils/environment'

import type {ParameterizedCapabilityValue} from '@vio/core/src/brand/capabilities/types/core'
import type {GoogleAnalyticsConfig} from '@vio/core/src/brand/capabilities/types/domains'

export const getGoogleTagMeasurementId = (
  googleAnalytics: ParameterizedCapabilityValue<GoogleAnalyticsConfig>
): string | undefined => {
  if (!googleAnalytics.enabled) return undefined

  return googleAnalytics.config.measurementIds[getNormalizedEnvironment()]
}
